import React, { useState } from 'react';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';

import TextInput from '../common/TextInput';
import LoadingSpinner from '../common/LoadingSpinner';

import Logo from '../assets/img/Kwenda-Logo.svg';
import styles from '../assets/css/auth.module.css';

import useApi from './useApi';

function ForgotPassword() {
  const navigate = useNavigate();
  const redirectToHome = () => navigate('../');
  const { actions: { requestPasswordReset }, status, error } = useApi({});
  const [email, setEmail] = useState('');

  const submit = (e) => {
    e.preventDefault();
    requestPasswordReset(email);
  };

  return (
    <div className={styles.auth_main}>
      <div className={styles.auth_form}>
        <div className={styles.auth_form_header}>
          <div>
            <h2>تأكيد البريد الإلكتروني</h2>
            <p style={{ marginTop: '10px' }}>سوف نساعدك على إعادة تعيين كلمة المرور</p>
          </div>
          <Link to="../">
            <img className={styles.auth_logo} alt="Kwenda Logo" src={Logo} />
          </Link>
        </div>
        {
          status === 'submitted' && <div className="success_message password_reset">
            <p>سيتم إرسال رابط إعادة تعيين كلمة المرور الى بريدك الإلكتروني</p>
            <button className="button large-button redirect_button" onClick={redirectToHome}>العودة للصفحة الرئيسية </button>
          </div>
        }
        {
          status !== 'submitted' &&
          <form>
            <TextInput
              label="البريد الإلكتروني"
              type="text"
              placeholder="email@example.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              error={''}
            />

            {error && <p
              className="error centered">
              <span className="iconify" data-icon="zondicons:exclamation-solid">
              </span>
              {error}
            </p>}

            <button className={classNames('button', styles.button)} onClick={submit}>
              تأكيد البريد الإلكتروني
              {status === 'submitting' && <LoadingSpinner />}
            </button>
            <div className={styles.auth_links}>
              <Link to="../login">العودة الى تسجيل الدخول</Link>
              <Link to="../login">العودة الى الصفحة الرئيسية</Link>
            </div>
          </form>
        }
      </div>
    </div>
  );
}

export default ForgotPassword;
